export function isDayPassed(date: Date): boolean {
    const dayInMilliseconds = 86400000;
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    return diff >= dayInMilliseconds;
  }
